function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgAreaDeServico = function SvgAreaDeServico(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M16.957 3.42a1.712 1.712 0 01.346 1.919h8.262c1.07 0 1.935.875 1.935 1.951v23.226a.98.98 0 01-.978.984H5.478a.98.98 0 01-.978-.984V7.29c0-1.076.865-1.951 1.935-1.951h.61a1.712 1.712 0 01.346-1.92c-.309-.31-.5-.738-.5-1.21 0-.94.76-1.709 1.696-1.709h7.174c.935 0 1.696.77 1.696 1.71 0 .47-.192.9-.5 1.21zm-1.196-.5c.38 0 .696-.32.696-.71 0-.39-.316-.71-.696-.71H8.587c-.38 0-.696.32-.696.71 0 .39.316.71.696.71h7.174zm0 1H8.587c-.38 0-.696.319-.696.709 0 .39.316.71.696.71h7.174c.38 0 .696-.32.696-.71 0-.39-.316-.71-.696-.71zM8.587 6.338H6.435a.943.943 0 00-.935.951V30.5h21V7.29a.943.943 0 00-.935-.951H8.587zm10.283 3.87a.5.5 0 110-1h4.782a.5.5 0 110 1H18.87zm-10.522 0a.5.5 0 110-1h1.435a.5.5 0 110 1H8.348zm3.826 0a.5.5 0 010-1h1.435a.5.5 0 010 1h-1.435zm1.173 4.474a.5.5 0 11-.433-.901A7.103 7.103 0 0116 13.08c3.975 0 7.196 3.258 7.196 7.274s-3.22 7.274-7.196 7.274c-3.975 0-7.196-3.258-7.196-7.274 0-1.506.455-2.945 1.29-4.155a.5.5 0 01.822.568 6.295 6.295 0 00-1.112 3.587c0 3.466 2.776 6.274 6.196 6.274s6.196-2.808 6.196-6.274c0-3.467-2.776-6.274-6.196-6.274-.93 0-1.832.207-2.653.602zm-.673 5.672a.5.5 0 11-1 0c0-2.413 1.936-4.371 4.326-4.371a.5.5 0 110 1c-1.836 0-3.326 1.508-3.326 3.37zm6.652 0a.5.5 0 111 0c0 2.412-1.936 4.37-4.326 4.37a.5.5 0 010-1c1.836 0 3.326-1.507 3.326-3.37z"
  }));
};
SvgAreaDeServico.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgAreaDeServico.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgAreaDeServico;